document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.uf-compare__review .jdgm-prev-badge').forEach((badge) => {

    const rating = badge.dataset.averageRating;
    const count = badge.dataset.numberOfReviews;
    const stars = badge.querySelector('.jdgm-prev-badge__stars');

    if (!rating || !count || !stars) return;

    const productLink = badge.closest('.uf-compare__details')
      ?.querySelector('.uf-compare__button')
      ?.getAttribute('href');

    if (!productLink) return;

    badge.innerHTML = '';

    badge.appendChild(stars);

    const score = document.createElement('span');
    score.className = 'uf-compare__review-score';
    score.textContent = rating;
    badge.appendChild(score);

    const link = document.createElement('a');
    link.className = 'uf-compare__review-count';
    link.href = `${productLink}#judgeme_product_reviews`;
    link.textContent = `（${count}件）`;

    badge.appendChild(link);
  });
});